module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "dense": "",
      "full-width": ""
    }
  }, [_vm._l((_vm.filteredActions), function(action) {
    return [(action.type === "divider") ? _c('v-divider', {
      key: action.id
    }) : [(_vm.exclude.indexOf(action.id) === -1) ? _c('v-list-tile', {
      key: action.id,
      attrs: {
        "disabled": action.disableIf && action.disableIf(_vm.appointment)
      },
      on: {
        "close": function($event) {
          _vm.visible = false
        },
        "click": function($event) {
          return _vm.itemAction(action)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(action.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(action.title))])], 1), _vm._v(" "), (action.extraActions) ? _vm._l((action.extraActions(_vm.appointment)), function(extra) {
      return _c('v-list-tile-action', {
        key: extra.icon
      }, [_c('v-btn', {
        attrs: {
          "outline": "",
          "outlined": "",
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return extra.action(_vm.appointment)
          }
        }
      }, [(extra.icon) ? _c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v(_vm._s(extra.icon))]) : _vm._e()], 1)], 1)
    }) : _vm._e()], 2) : _vm._e()]]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-774a2996","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/actions/ActionList.vue
// module id = 1471
// module chunks = 9